import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const DURATION = 1500;

// The number with the browser's separators, as many decimals as it was
// typed with
const formatCount = (number, decimals) =>
  number.toLocaleString(navigator.languages?.[0], {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

// A count up in the app preview: counts from 0 to its value, as the app does
const CountUpPreview = ({ value, prefix, suffix, label }) => {
  const target = Number(value);
  const decimals = (String(value).split('.')[1] || '').length;
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!Number.isFinite(target)) return undefined;
    let frame;
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min((now - start) / DURATION, 1);
      // Fast at first, slowing down towards the number
      setCurrent(target * (1 - (1 - progress) ** 3));
      if (progress < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [target]);

  if (value === '' || !Number.isFinite(target)) {
    return null;
  }
  return (
    <div className="app-preview-counter">
      <div className="app-preview-counter__value">
        {prefix}
        {formatCount(current, decimals)}
        {suffix}
      </div>
      {label ? <div className="app-preview-counter__label">{label}</div> : null}
    </div>
  );
};

CountUpPreview.propTypes = {
  value: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  label: PropTypes.string,
};

CountUpPreview.defaultProps = {
  value: '',
  prefix: '',
  suffix: '',
  label: '',
};

export default CountUpPreview;
